module.exports = __webpack_public_path__ + "img/minting-shape2.b703c6d7.png";